import { type ReactNode } from 'react';
import { clx } from '@medusajs/ui';

import type { ClassValue } from '@modules/common/types';

type ContainerElement =
  | 'div'
  | 'section'
  | 'main'
  | 'article'
  | 'aside'
  | 'header'
  | 'footer'
  | 'nav';

type ContainerProps = {
  as?: ContainerElement;
  children: ReactNode;
  className?: ClassValue;
} & Omit<React.HTMLAttributes<HTMLElement>, 'children' | 'className'>;

const Container = ({
  as: Tag = 'div',
  className,
  children,
  ...props
}: ContainerProps) => {
  return (
    <Tag
      className={clx('mx-auto w-full max-w-[1440px] px-6', className)}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Container;
